import DebtRelief from 'partial/OfferManager/modules/DebtRelief/DebtReliefController';

export default DebtRelief;
